import { useContext, useEffect, useRef } from 'react'
import { UGEContext } from '../../context'
import { Grid } from '../style'
import { AspectRatio, Resize } from './style'

type Props = {
    className?: string
}

const UGECropEditor = ({ className }: Props) => {
    const hasCropRef = useRef<boolean>(false)
    const { crop, dimensions, trackGAEvent } = useContext(UGEContext)

    useEffect(() => {
        if (crop) {
            const hasHeightChanged = crop.height !== dimensions.height
            const hasWidthChanged = crop.width !== dimensions.width

            hasCropRef.current = hasHeightChanged || hasWidthChanged
        } else {
            hasCropRef.current = false
        }
    }, [crop, dimensions])

    useEffect(() => {
        return () => {
            if (hasCropRef.current) {
                trackGAEvent('crop_content_success')
            }
        }
    }, [trackGAEvent])

    return (
        <Grid className={className}>
            <AspectRatio />
            <Resize />
        </Grid>
    )
}

export default UGECropEditor
